import { useState } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useAddOfficers = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const addOfficer = async (officerData) => {
    setLoading(true);
    setSuccess(false);
    setError('');

    try {
  const response = await axiosApi.post('/iaOfficers', officerData);
      console.log('API Response:', response.data);

      if (response.data.status === 'success') {
        setSuccess(true);
        return { success: true };
      } else {
        setError(response.data.message || 'Failed to add officer.');
        return { success: false };
      }
    } catch (err) {
      console.error('Add officer error:', err);
      setError(err.response?.data?.message || 'Something went wrong.');
      return { success: false };
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    success,
    error,
    addOfficer,
  };
};

export default useAddOfficers;
